module.exports = __webpack_public_path__ + "static/media/mk.f26a7830.svg";